import React from "react";
import SEOLandingPage from "../../../components/tools/SEOLandingPage";

const OtterAIAlternative: React.FC = () => {
  return (
    <SEOLandingPage
      // SEO
      title="Best Otter.ai Alternative for Students 2025 | YouWo AI"
      metaDescription="Looking for an Otter.ai alternative for students? YouWo AI transcribes lectures, creates study notes, and generates flashcards. Free AI transcription for education."
      keywords="otter ai alternative, otter.ai competitor, transcription app, lecture transcription, meeting notes ai, voice to text, speech to text"
      canonicalUrl="https://youwo.ai/tools/otter-ai-alternative"
      // Hero
      headline="Otter.ai Alternative Built for Students"
      subheadline="Otter.ai is great for meetings, but students need more. YouWo AI transcribes lectures AND turns them into study materials, flashcards, and quizzes."
      heroIcon="lucide:mic"
      heroIconColor="text-teal-500"
      heroIconBg="bg-teal-50"
      // Problem/Solution
      problemTitle="Otter.ai Wasn't Built for Students"
      problemDescription="Otter.ai focuses on business meetings. For students, you get a transcript but then have to manually create notes, highlight key concepts, and make study materials. That's extra work you don't need."
      solutionTitle="Transcription + Study Tools in One"
      solutionDescription="YouWo AI transcribes your lectures with the same accuracy, then goes further: AI identifies key concepts, creates structured notes, and generates flashcards and quizzes for exam prep."
      // Comparison
      competitorName="Otter.ai"
      comparisonPoints={[
        { feature: "Lecture Transcription", youwoai: true, competitor: true },
        { feature: "Speaker Identification", youwoai: true, competitor: true },
        { feature: "Study Notes Generation", youwoai: true, competitor: false },
        { feature: "Flashcard Creation", youwoai: true, competitor: false },
        { feature: "Quiz Generation", youwoai: true, competitor: false },
        { feature: "YouTube Support", youwoai: true, competitor: false },
        { feature: "Student Pricing", youwoai: "Free Tier", competitor: "$10/mo" },
        { feature: "Offline Recording", youwoai: true, competitor: "Premium" },
      ]}
      // Features
      features={[
        {
          icon: "lucide:globe",
          title: "100+ Languages",
          description: "Transcribe lectures in over 100 languages with automatic detection.",
        },
        {
          icon: "lucide:clock",
          title: "Clickable Timestamps",
          description: "Click any part of your notes to jump to that moment in the recording.",
        },
        {
          icon: "lucide:headphones",
          title: "Accurate Transcription",
          description: "State-of-the-art speech recognition for clear, accurate lecture transcripts.",
        },
        {
          icon: "lucide:layers",
          title: "Active Recall Flashcards",
          description: "Generate flashcards using active recall - the most effective learning technique.",
        },
        {
          icon: "lucide:youtube",
          title: "YouTube Integration",
          description: "Transcribe and study from any YouTube lecture or educational video.",
        },
        {
          icon: "lucide:help-circle",
          title: "Practice Quizzes",
          description: "Test your understanding with AI-generated quizzes from your lectures.",
        },
      ]}
      // CTA
      ctaText="Try YouWo AI Free"
      ctaLink="https://apps.apple.com/app/youwo-ai-agent/id6760689478"
      // Related
      relatedTools={[
        { name: "Audio Transcriber", href: "/tools/audio-transcriber", icon: "lucide:mic" },
        { name: "Lecture Notes AI", href: "/tools/lecture-notes", icon: "lucide:graduation-cap" },
        { name: "Meeting Notes", href: "/tools/meeting-notes", icon: "lucide:users" },
        { name: "YouTube Summarizer", href: "/tools/youtube-summarizer", icon: "lucide:youtube" },
      ]}
    />
  );
};

export default OtterAIAlternative;
